import React from 'react';
import { cn } from '../../utils/cn.ts';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: string;
    error?: string;
    fullWidth?: boolean;
    helperText?: string;
    resize?: 'none' | 'vertical' | 'both';
    ref?: React.Ref<HTMLTextAreaElement>;
}

const resizeClasses = {
    none: 'resize-none',
    vertical: 'resize-y',
    both: 'resize',
};

const NativeTextarea = 'textarea';

export const Textarea: React.FC<TextareaProps> = ({
    label,
    error,
    fullWidth = true,
    helperText,
    resize = 'none',
    className,
    disabled,
    id,
    rows = 3,
    ref,
    ...props
}) => {
    const generatedId = React.useId();
    const textareaId = id ?? generatedId;

    return (
        <div className={cn(fullWidth && 'w-full', className)}>
            {label ? <label 
                    htmlFor={textareaId}
                    className="mb-1 block font-medium text-gray-700 text-sm dark:text-gray-300"
                >
                    {label}
                </label> : null}
            
            <NativeTextarea
                ref={ref}
                id={textareaId}
                disabled={disabled}
                rows={rows}
                className={cn(
                    'block w-full rounded-lg border',
                    'bg-white dark:bg-surface-dark',
                    'text-gray-900 dark:text-white',
                    'placeholder-gray-400 dark:placeholder-gray-500',
                    'focus-ring transition-colors',
                    'px-3 py-2 text-sm',
                    resizeClasses[resize],
                    error 
                        ? 'border-red-500 focus:ring-red-500' 
                        : 'border-gray-300 hover:border-gray-400 dark:border-border-dark dark:hover:border-gray-600',
                    disabled && 'cursor-not-allowed bg-gray-50 opacity-60 dark:bg-gray-800'
                )}
                {...props}
            />

            {(error || helperText) ? <p className={cn('mt-1 text-xs', error ? 'text-red-500' : 'text-gray-500 dark:text-gray-400')}>
                    {error || helperText}
                </p> : null}
        </div>
    );
};
